import type { Locale } from 'date-fns'
import enUS from 'date-fns/locale/en-US/index'

export const locales: Record<string, Locale> = {
	en: enUS
}
